export const authenticationResultEnum = {
    Error: -100,
    InvalidUsernameOrPassword: 0,
    AccountLocked: 10,
    PasswordExpired: 20,
    EmailConfirmationRequired: 50,
    TwoFARequired: 60,
    Success: 100
};



//export const worksheetControlTypes = {
//    Worksheet
//}
//public const string Textbox = "textbox";
//public const string Textarea = "textarea";
//public const string Numeric = "numeric";
//public const string Datetime = "datetime";
//public const string Date = "date";
//public const string Time = "time";
//public const string Radio = "radio";
//public const string Checkbox = "checkbox";
//public const string Multiselect = "multiselect";
//public const string Dropdown = "dropdown";